import { atom } from 'jotai';
import { atomWithRefresh } from 'jotai/utils';
import {
    getLogbookPersonalEntry,
    createOrUpdateLogbookPersonalEntry,
} from '../../modules/exerciseAPI';
import {
    CreateOrUpdateLogbookPersonalEntryRequest,
    LogbookPersonalEntryDto,
} from '../../modules/interfaces';

export const personalEntriesAtom = atomWithRefresh<
    Promise<LogbookPersonalEntryDto[]>
>(() => getLogbookPersonalEntry());

// The actual data that should currently be shown by the edit-entry view. This must always be up-to-date, as it is used by the save-logic
export const personalEntryEditAtom =
    atom<CreateOrUpdateLogbookPersonalEntryRequest>({ Title: '', Text: '' });

export const updatePersonalEntryAtom = atom(null, async (get, set) => {
    const value = get(personalEntryEditAtom);
    if (value.Id == null) {
        // No data
        if (!value.Text && !value.Title) {
            return;
        }
    } else {
        const notes = await get(personalEntriesAtom);
        const existing = notes.find((x) => x.Id === value.Id);
        // No changes
        if (existing.Text === value.Text && existing.Title === value.Title) {
            return;
        }
    }
    await createOrUpdateLogbookPersonalEntry(value);
    set(personalEntriesAtom);
});
